import './styles/index.scss';

import { KeyStateTracker } from './util/KeyStateTracker';
import { KeyCodes } from './util/Keyboard';
import { initializeIcons, loadTheme, createTheme } from '@fluentui/react';

import * as ReactDOM from 'react-dom';

import { unregisterServiceWorker } from './registerServiceWorker';
import routes from './routes';

unregisterServiceWorker();
/* NOTE(Adrian): The CDNs that hosted the Fluent UI icons were moved and it's either update to 8.109.0
  or update the CDN urls. I opted for the latter, since updating the package could have larger ramifications

  Here is the Github Issue to learn more: https://github.com/microsoft/fluentui/issues/33612
*/
initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20241209.001/assets/icons/');
loadTheme(
  createTheme({
    defaultFontStyle: { fontFamily: 'inter' },
  })
);

KeyStateTracker.getInstance().attachEventListeners([KeyCodes.option]);

ReactDOM.render(routes, document.getElementById('root') as HTMLElement);
